// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__tpA6d","el":"Counter_el__P7JVG","active":"Counter_active__azabr","size_small":"Counter_size_small__b6ZTn"};